import React, { useEffect, useMemo } from "react"
import ResourceTabs from "./resource-tabs"
import ResourceList from "./resource-list"
import CustomProgressBar from "src/components/custom-progress-bar"
import { Box, useMediaQuery, useTheme } from "@material-ui/core"
import useASTStore from "src/v2/utils/AST-store"
import useStore from "src/v2/utils/store"
import TaskCardList from "./task-card-list"

export default function ResourceViewer() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"))

  const getTotalProgress = useASTStore((s) => s.getTotalProgress)
  const selectedResourseType = useASTStore((s) => s.selectedResourseType)
  const getTasks = useStore((s) => s.getTasks)
  const oneReview = useStore((s) => s.oneReview)
  const completedTasks = useStore((s) => s.completedTasks)

  // Call getTasks on load with reviewId
  useEffect(() => {
    if (getTasks && oneReview?._id) {
      getTasks(oneReview._id)
    }
  }, [getTasks, oneReview?._id])

  // Recalculate progress when completedTasks changes
  const progressObj = useMemo(
    () => (getTotalProgress ? getTotalProgress() : { completed: 0, total: 0 }),
    [getTotalProgress, completedTasks]
  )
  const progress = progressObj.total
    ? Math.floor((progressObj.completed / progressObj.total) * 100)
    : 0

  const showProgressCheckboxFormalMapping = window["config"]?.SHOW_PROGRESS_CHECKBOX_FORMAL_MAPPING === "YES"

  return (
    <Box
      p={isMobile ? 1 : 3}
    >
      {showProgressCheckboxFormalMapping && (
        <Box>
          <CustomProgressBar showPercentage={false} progress={progress} />
          <Box mt={1} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
            <Box>
              Completed {progressObj.completed}/{progressObj.total} review tasks
            </Box>
          </Box>
        </Box>
      )}

      <Box>
        <ResourceTabs />
      </Box>

      {selectedResourseType && (
        <Box pt={2}>
          <ResourceList />
        </Box>
      )}

      <Box mt={2}>
        <TaskCardList />
      </Box>
    </Box>
  )
}